module.exports = __webpack_public_path__ + "img/ywbk06_en.80975b65.jpg";